import React from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from "./contexts/LanguageContext";
import { Header } from "./components/header/Header";
import { Footer } from "./components/footer/Footer";

import Util from "./util/util";

// All Users
import Home from "./pages/home/Home";
import Search from "./pages/search/Search";
import Product from "./pages/product/Product";
import Contact from "./pages/static/Contact";
import Terms from "./pages/static/Terms";
import SellingList from "./pages/sellinglist/SellingList";
import Categories from "./pages/categories/Categories";
import Payments from "./pages/payments/Payments";
import FrequentQuestions from "./pages/faq/FrequentQuestions";
import Poll from "./pages/poll/Poll";

import Beforeexit from "./components/beforeexit/Beforeexit";

// Logged in Only
import Settings from "./pages/settings/Settings";
import Notifications from "./pages/notifications/Notifications";
import Profile from "./pages/profile/Profile";
import Statistic from "./pages/statistic/Statistic";
import Messages from "./pages/messages/Messages";
import NewProduct from "./pages/addproducts/NewProduct";
import AboutUs from "./pages/aboutus/About";
import BoughtList from "./pages/boughtlist/Boughtlist";
import OrgProducts from "./pages/orgproducts/OrgProducts";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import AdminPanel from "./pages/adminpanel/AdminPanel";
import PlanSubscription from "./pages/plansubscription/PlanSubscription";
import UserPayPanel from "./pages/userpaypanel/Userpaypanel";

// Not logged in Only
import Register from "./pages/register/Register";

var oldLinkPath = window.location.href;

function App() {
  var navigate = useNavigate();
  var loggedIn = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
      ? JSON.parse(localStorage.getItem("user_data")).id
        ? true
        : false
      : false
    : false;
  var is_admin = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
      ? JSON.parse(localStorage.getItem("user_data")).is_admin
        ? true
        : false
      : false
    : false;

  var titleAfter = " - OPK.ba";

  if (oldLinkPath !== window.location.href) {
    window.scrollTo(0, 0);
    oldLinkPath = window.location.href;
  }

  function logAllErrors(evt) {
    if (evt && evt.error && evt.error) {
      Util.saveCustomEvent(
        "Error: " + evt.error.message + "\n\nLink:" + window.location.href + "\n\nStack:" + evt.error.stack
      );
      console.error(evt);
    }
    evt.preventDefault();
    return false;
  }

  window.removeEventListener("error", logAllErrors);
  window.addEventListener("error", logAllErrors);

  if (window.__opkLastLoggedPage !== window.location.href) {
    window.__opkLastLoggedPage = window.location.href;
    setTimeout(() => {
      Util.trackEvent("page_open", {
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    }, 0);
  }

  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <Header navigate={navigate} />
          <main className="Page">
            <Routes>
          {/* All Users */}
          <Route path="/" element={<Home pageTitle={"Početna stranica" + titleAfter} />} />
          <Route path="/:lang" element={<Home pageTitle={"Početna stranica" + titleAfter} />} />
          <Route path="/glasaj/:param1" element={<Poll />} />
          <Route path="/:lang/glasaj/:param1" element={<Poll />} />
          <Route path="/pretraga" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/:lang/pretraga" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/k/:param1" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/:lang/k/:param1" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/k/:param1/:param2" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/:lang/k/:param1/:param2" element={<Search pageTitle={"Pretraga" + titleAfter} />} />
          <Route path="/p/:param1" element={<Product pageTitle={titleAfter} />} />
          <Route path="/:lang/p/:param1" element={<Product pageTitle={titleAfter} />} />
          <Route path="/radnja/:param1" element={<Profile pageTitle={titleAfter} />} />
          <Route path="/:lang/radnja/:param1" element={<Profile pageTitle={titleAfter} />} />
          <Route
            path="/svekategorije"
            element={<Categories pageTitle={"Kupujem" + titleAfter} navigate={navigate} />}
          />
          <Route
            path="/:lang/svekategorije"
            element={<Categories pageTitle={"Kupujem" + titleAfter} navigate={navigate} />}
          />
          <Route path="/kontakt" element={<Contact pageTitle={"Kontakt" + titleAfter} />} />
          <Route path="/:lang/kontakt" element={<Contact pageTitle={"Kontakt" + titleAfter} />} />
          <Route path="/onama" element={<AboutUs pageTitle={"O nama" + titleAfter} navigate={navigate} />} />
          <Route path="/:lang/onama" element={<AboutUs pageTitle={"O nama" + titleAfter} navigate={navigate} />} />
          <Route path="/placanje" element={<Payments pageTitle={"Plan Plaćanja" + titleAfter} navigate={navigate} />} />
          <Route path="/:lang/placanje" element={<Payments pageTitle={"Plan Plaćanja" + titleAfter} navigate={navigate} />} />
          <Route
            path="/uslovikoristenja"
            element={<Terms pageTitle={"Uslovi Koristenja" + titleAfter} navigate={navigate} />}
          />
          <Route
            path="/:lang/uslovikoristenja"
            element={<Terms pageTitle={"Uslovi Koristenja" + titleAfter} navigate={navigate} />}
          />
          <Route path="/kupovina" element={<SellingList pageTitle={"Kupujem" + titleAfter} navigate={navigate} />} />
          <Route path="/:lang/kupovina" element={<SellingList pageTitle={"Kupujem" + titleAfter} navigate={navigate} />} />
          <Route
            path="/pitanja"
            element={<FrequentQuestions pageTitle={"Često postavljena pitanja" + titleAfter} navigate={navigate} />}
          />
          <Route
            path="/:lang/pitanja"
            element={<FrequentQuestions pageTitle={"Često postavljena pitanja" + titleAfter} navigate={navigate} />}
          />

          {/* Logged in Only */}
          <Route
            path="/mojprofil"
            element={loggedIn ? <Profile myprofile="1" pageTitle={titleAfter} /> : <Navigate to="/" />}
          />
          <Route
            path="/:lang/mojprofil"
            element={loggedIn ? <Profile myprofile="1" pageTitle={titleAfter} /> : <Navigate to="/" />}
          />
          <Route
            path="/statistika"
            element={loggedIn ? <Statistic myprofile="1" pageTitle={"Statistika" + titleAfter} /> : <Navigate to="/" />}
          />
          <Route
            path="/:lang/statistika"
            element={loggedIn ? <Statistic myprofile="1" pageTitle={"Statistika" + titleAfter} /> : <Navigate to="/" />}
          />
          <Route
            path="/podesavanja"
            element={
              loggedIn ? <Settings pageTitle={"Podešavanja" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/:lang/podesavanja"
            element={
              loggedIn ? <Settings pageTitle={"Podešavanja" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/obavjestenja"
            element={
              loggedIn ? (
                <Notifications pageTitle={"Obavještenja" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/obavjestenja"
            element={
              loggedIn ? (
                <Notifications pageTitle={"Obavještenja" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/poruke"
            element={
              loggedIn ? <Messages pageTitle={"Poruke" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/:lang/poruke"
            element={
              loggedIn ? <Messages pageTitle={"Poruke" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/poruke/:param1/:param2"
            element={loggedIn ? <Messages pageTitle={"Poruke" + titleAfter} singleMessage="1" /> : <Navigate to="/" />}
          />
          <Route
            path="/:lang/poruke/:param1/:param2"
            element={loggedIn ? <Messages pageTitle={"Poruke" + titleAfter} singleMessage="1" /> : <Navigate to="/" />}
          />
          <Route
            path="/dodajproizvod"
            element={
              loggedIn ? (
                <NewProduct pageTitle={"Dodajte proizvod" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/dodajproizvod"
            element={
              loggedIn ? (
                <NewProduct pageTitle={"Dodajte proizvod" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/novaprodaja"
            element={
              loggedIn ? <NewProduct pageTitle={"Novi oglas" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/:lang/novaprodaja"
            element={
              loggedIn ? <NewProduct pageTitle={"Novi oglas" + titleAfter} navigate={navigate} /> : <Navigate to="/" />
            }
          />
          <Route
            path="/kupljeniproizvodi"
            element={
              loggedIn ? (
                <BoughtList pageTitle={"Kupljeni proizvodi" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/kupljeniproizvodi"
            element={
              loggedIn ? (
                <BoughtList pageTitle={"Kupljeni proizvodi" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/organizovanjeproizvoda"
            element={
              loggedIn ? (
                <OrgProducts pageTitle={"Organizovanje proizvoda" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/organizovanjeproizvoda"
            element={
              loggedIn ? (
                <OrgProducts pageTitle={"Organizovanje proizvoda" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/zamjeniproizvod/:param1"
            element={
              loggedIn ? (
                <NewProduct isEditing={true} pageTitle={"Zamjena oglasa" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/zamjeniproizvod/:param1"
            element={
              loggedIn ? (
                <NewProduct isEditing={true} pageTitle={"Zamjena oglasa" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/adminpanel"
            element={
              loggedIn && is_admin ? (
                <AdminPanel pageTitle={"Dodajte proizvod" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/adminpanel"
            element={
              loggedIn && is_admin ? (
                <AdminPanel pageTitle={"Dodajte proizvod" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/plansubscription"
            element={
              loggedIn && is_admin ? (
                <PlanSubscription pageTitle={"Plan Subscription" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/plansubscription"
            element={
              loggedIn && is_admin ? (
                <PlanSubscription pageTitle={"Plan Subscription" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/istorijauplata"
            element={
              loggedIn ? (
                <UserPayPanel pageTitle={"Istorija uplata" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/:lang/istorijauplata"
            element={
              loggedIn ? (
                <UserPayPanel pageTitle={"Istorija uplata" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          {/* Not logged in Only */}
          <Route
            path="/registracija"
            element={
              !loggedIn ? (
                <Register pageTitle={"Registracija" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/mojprofil" />
              )
            }
          />
          <Route
            path="/:lang/registracija"
            element={
              !loggedIn ? (
                <Register pageTitle={"Registracija" + titleAfter} navigate={navigate} />
              ) : (
                <Navigate to="/mojprofil" />
              )
            }
          />
          <Route
            path="/lozinka"
            element={
              !loggedIn ? (
                <ForgotPassword pageTitle={"Zaboravili ste lozinku" + titleAfter} navigate={navigate} />
              ) : (
                <ForgotPassword pageTitle={"Zamjena lozinke" + titleAfter} navigate={navigate} />
              )
            }
          />
          <Route
            path="/:lang/lozinka"
            element={
              !loggedIn ? (
                <ForgotPassword pageTitle={"Zaboravili ste lozinku" + titleAfter} navigate={navigate} />
              ) : (
                <ForgotPassword pageTitle={"Zamjena lozinke" + titleAfter} navigate={navigate} />
              )
            }
          />
            </Routes>
          </main>
          <Footer navigate={navigate} />
          <Beforeexit navigate={navigate} />
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
